var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryBoxArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#323232",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01,16.972l1.996,1.996l-1.996,1.996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.019,14.976v1.996c0,1.103 0.894,1.996 1.996,1.996h4.991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.012,8.987v-1.996c0,-1.103 -0.894,-1.996 -1.996,-1.996h-4.991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.021,6.991l-1.996,-1.997l1.996,-1.996"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: 1.5293,
    d: "M11,8.931v-3.844c0,-0.416 -0.222,-0.801 -0.582,-1.009l-3.33,-1.922c-0.36,-0.208 -0.804,-0.208 -1.165,0l-3.329,1.922c-0.36,0.208 -0.582,0.593 -0.582,1.009v3.844c0,0.416 0.222,0.801 0.582,1.009l3.329,1.922c0.36,0.208 0.804,0.208 1.165,0l3.329,-1.922c0.361,-0.208 0.583,-0.593 0.583,-1.009Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5293,
    d: "M2.167,4.505l4.339,2.504l4.338,-2.504"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5293,
    d: "M6.51,7.01v5.01"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: 1.5293,
    d: "M21.988,18.913v-3.844c0,-0.416 -0.222,-0.801 -0.582,-1.009l-3.329,-1.922c-0.36,-0.208 -0.804,-0.208 -1.165,0l-3.329,1.922c-0.361,0.208 -0.583,0.592 -0.583,1.008v3.844c0,0.416 0.222,0.801 0.582,1.009l3.329,1.922c0.36,0.208 0.804,0.208 1.165,0l3.329,-1.922c0.361,-0.208 0.583,-0.592 0.583,-1.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5293,
    d: "M13.156,14.486l4.338,2.505l4.339,-2.505"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5293,
    d: "M17.49,16.99v5.01"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryBoxArrows);
export default __webpack_public_path__ + "static/media/Delivery-Box-Arrows.f3486fa203b7b8afe1df3ac8122f7460.svg";
export { ForwardRef as ReactComponent };